import { useMemo } from "react"
import { SECUREFILE_ONLY } from "@/constants"
import { useOdPermissions } from "./useOdPermissions"

export const useIsSecureFileOnly = () => {
  const permissions = useOdPermissions()
  const isSecureFileOnly = useMemo(() => {
    return permissions.has(SECUREFILE_ONLY)
  }, [permissions])
  return isSecureFileOnly
}